import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import ALlogo from "../../assets/ALDOT-Logo.png";
import MI_logo from "../../assets/MDOT LOGO.png";
import axios from "axios";

import searchIcon from "../../assets/search-icon.svg";
import CountryFilter from "../../components/Filters/CountryFilter";
import paginationValue from "../../common/paginationValue.json";
import Pagination from "../../components/Layout/Pagination";
import loader from "../../assets/loader.svg";
import toast from "react-hot-toast";
import AxiosInstance from "../../utils/axiosInstance";
import favoriteImg from "../../assets/bookmark-favorite.svg";
import AgencyFilter from "../../components/Filters/AgencyFilter";
import { useNavigate, Link } from "react-router-dom";
import CronJobSteps from "./StepComponent";
import { useLocation } from "react-router-dom";

export default function AL_TEMP() {
  const [storedState, setstoredState] = useState(
    JSON.parse(localStorage.getItem("selectedState"))
  );
  const [selectedValue, setSelectedValue] = useState("");
  const [country, setCountry] = useState("");
  const [resetTrue, setResetTrue] = useState(false);
  const [currentPage, setCurrentPage] = useState(paginationValue.currentPage);
  const [pageLimit, setPageLimit] = useState(paginationValue.limit);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [APICall, setAPICAll] = useState(false);
  const [favloader, setFavloader] = useState(false);
  const [selectedState, setSelectedState] = useState(
    JSON.parse(localStorage.getItem("selectedState")) || null
  );
  const [showloader, setloader] = useState(false);
  const [DataList, setDataList] = useState([]);
  const [steps, setSteps] = useState([]);

  const [Agency, setAgency] = useState("");
  const [uniqueAgency, setUniqueAgency] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const docType = location.state?.doc_type || "AL";

  // useEffect(() => {
  //   console.log("Received doc_type:", docType);
  // }, []);
  const abortControllerRef = useRef(null);
  useEffect(() => {
    if (currentPage > 0) {
      getDirectoryList();
    }
  }, [currentPage, country, Agency]);

  useEffect(() => {
    if (APICall) getDirectoryList();
  }, [APICall]);

  const getDirectoryList = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    setAPICAll(false);
    setloader(true);

    const controller = new AbortController();
    abortControllerRef.current = controller;
    const queryParams = new URLSearchParams({
      county: country,
      page: currentPage,
      limit: pageLimit,
      doc_type: docType,
      search_text: searchValue,
      agency: Agency,
    });

    const currentTime = new Date().getTime();
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_TEMPDATA}?currentTime=${currentTime}&${queryParams}`,
      { signal: controller.signal }
    )
      .then((response) => {
        if (response.data?.data) {
          setDataList(response.data?.data);
          setUniqueAgency([
            ...new Map(
              response.data.data
                .filter((item) => item.CERTIFYINGAGENCY) // filter out null/undefined
                .map((item) => [
                  item.CERTIFYINGAGENCY,
                  {
                    label: item.CERTIFYINGAGENCY,
                    value: item.CERTIFYINGAGENCY,
                  },
                ])
            ).values(),
          ]);
          setPageLimit(response.data?.limit);
          setTotalRecords(response.data?.total_records);
          setTotalPages(response.data?.total_pages);
          setCurrentPage(response.data?.page);
          setSteps(response.data?.cron_steps);
          setloader(false);
          toast.success(response.data?.message);
        } else {
          setDataList([]);
          setSteps([]);
          setloader(false);
          toast.success(response.data?.message);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
          // console.log("Aborted");
          //toast.error(error?.message);
        } else {
          toast.error(error?.message);
          setloader(false);
        }
      });
  };

  const handleCountrySelect = (country) => {
    setCountry(country);
    setCurrentPage(1);
    setResetTrue(false);
  };

  const handleAgencySelect = (agency) => {
    setAgency(agency);
    setCurrentPage(1);
    setResetTrue(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleReset = () => {
    setResetTrue(true);
    setSelectedValue("");
    setCountry("");
    setSearchValue("");
    setAgency("");
    setCurrentPage(1);
    setAPICAll(true);
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    setAPICAll(true);
  };

  const handleFilterChange = (event) => {
    setResetTrue(true);
    setSelectedValue("");
    setCountry("");
    setSearchValue("");
    setAgency("");
    setCurrentPage(1);
    setAPICAll(true);
  };

  return (
    <>
      <Header />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md bg-primary mb-3">
              <p className="text-white point-22"></p>
              <h1 className="text-secondary fw-boldest point-42">
                {docType}DOT TEMP DATA{" "}
              </h1>
            </div>
            <div className="col-6 col-md-auto text-end my-3">
              <img
                src={
                  storedState?.label == docType
                    ? ALlogo
                    : storedState?.label == docType
                    ? MI_logo
                    : ""
                }
                style={{ height: "70px", width: "auto" }} // Added style attribute to reduce size
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-12 col-md-auto">
                      <div className="input-group mb-3">
                        <span
                          className="input-group-text text-uppercase text-secondary fw-bold border-0 bg-white rounded-0"
                          id="basic-addon1"
                        >
                          Filter:
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-md">
                      <div className="input-group mb-3">
                        <div style={{ width: "100%" }}>
                          <AgencyFilter
                            agencyList={uniqueAgency} // array of { label, value }
                            onSelectAgency={handleAgencySelect} //(selected) => setSelectedAgency(selected)
                            reset={resetTrue}
                            ismultiple={false}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col">
                      <div className="input-group mb-3">
                        <div style={{ width: "100%" }}>
                          <CountryFilter
                            onSelectCountry={handleCountrySelect}
                            reset={resetTrue}
                            state={docType}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control fw-bolder text-white bg-secondary rounded-0 border border-1 border-secondary placeholder-white point-18"
                          placeholder="Search"
                          aria-label="Search"
                          aria-describedby="button-addon2"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                        />
                        <button
                          className="btn btn-primary text-secondary rounded-0 border-0"
                          type="button"
                          id="button-addon2"
                          onClick={handleSearchClick}
                        >
                          <span className="point-20">
                            <img src={searchIcon} alt="icon" />
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="col-12 col-md mb-2">
                      <div className="input-group mb-3">
                        <input
                          type="button"
                          className="form-control btn btn-link text-uppercase me-2 text-danger text-start"
                          placeholder="Reset"
                          aria-label="Reset"
                          value="Reset"
                          onClick={() => handleReset()}
                          aria-describedby="basic-addon1"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md mb-2">
                      <span className="point-22 text-black-50 fw-light">
                        <b>Total : {totalRecords} </b>
                      </span>
                    </div>
                  </div>

                  {steps.length > 0 && (
                    <CronJobSteps
                      doc_type={docType}
                      initialSteps={steps}
                      setApiCall={setAPICAll}
                    />
                  )}

                  <div>
                    {!showloader ? (
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover centered">
                          <thead className="table-dark">
                            <tr>
                              {docType === "AL" && (
                                <>
                                  <th>BUSINESS NAME</th>
                                  <th>CERTIFYING AGENCY</th>
                                  <th>WEBSITE</th>
                                  <th>EMAIL</th>
                                  <th>PHONE</th>
                                  <th>FAX</th>
                                  <th>ADDRESS</th>
                                  <th>ADDRESS CITY</th>
                                  <th>ADDRESS COUNTY</th>           
                                  <th>ADDRESS STATE</th>
                                  <th>ZIPCODE</th>
                                  <th>Latitude</th>
                                  <th>Longitude</th>
                                  <th>CONTACT PERSON</th>
                                  <th>NAICS CODES</th>
                                  <th>SPECIALTIES</th>
                                  <th>ACCOUNT ID</th>
                                  <th>CONTACT ID</th>
                                  <th>AGENCY ID</th>
                                  <th>DATE</th>
                                </>
                              )}

                              {docType === "MI" && (
                                <>
                                  <th>BUSINESS NAME</th>
                                  <th>CERTIFYING AGENCY</th>
                                  <th>CERTIFICATION DATE</th>
                                  <th>MDOT_CODE</th>
                                  <th>WEBSITE</th>
                                  <th>EMAIL</th>
                                  <th>PHONE</th>
                                  <th>FAX</th>
                                  <th>ADDRESS</th>
                                  <th>ADDRESS CITY</th>
                                  <th>ADDRESS COUNTY</th>
                                  <th>ADDRESS STATE</th>
                                  <th>ZIPCODE</th>
                                  <th>Latitude</th>
                                  <th>Longitude</th>
                                  <th>CONTACT PERSON</th>
                                  <th>NAICS CODES</th>
                                  <th>SPECIALTIES</th>
                                  <th>ACCOUNT ID</th>
                                  <th>CONTACT ID</th>
                                  <th>AGENCY ID</th>
                                  <th>DATE</th>
                                </>
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {DataList.length > 0 ? (
                              DataList.map((row, index) => (
                                <tr key={index}>
                                  <td>{row.NAME}</td>
                                  <td>{row.CERTIFYINGAGENCY}</td>

                                  {docType === "MI" && (
                                    <>
                                      <td>{row.certdate}</td>
                                      <td>{row.mdot_codes}</td>
                                    </>
                                  )}

                                  <td>{row.WEBSITE}</td>
                                  <td>{row.EMAIL}</td>
                                  <td>{row.PHONE}</td>
                                  <td>{row.FAX}</td>
                                  <td>{row.ADDRESS}</td>
                                  <td>{row.CITY}</td>
                                  <td>{row.county_name}</td>
                                  <td>
                                    {row.STATE_NAME}({row.STATE})
                                  </td>
                                  <td>{row.ZIP}</td>
                                  <td>{row.lat}</td>
                                  <td>{row.long}</td>
                                  <td>
                                    {row.CONTACT_NAME} {row.Contact_last_name}
                                  </td>
                                  <td>{row.NACIS_CODES}</td>
                                  <td>{row.Specialties}</td>
                                  <td>{row.account_id}</td>
                                  <td>{row.contact_id}</td>
                                  <td>{row.agency_id}</td>
                                  <td>{row.date_entered}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="22">No data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="loader">
                        <img src={loader} alt="loading" />
                      </div>
                    )}
                  </div>

                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    pageLimit={pageLimit}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
